export default function Logo({ size = 32, showText = false }) {
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
      <img
        src="/ye-music-logo.png"
        alt="YE Music"
        style={{
          height: size,
          width: "auto",
          userSelect: "none",
          filter: "drop-shadow(0 0 28px rgba(124, 108, 255, 0.35)) drop-shadow(0 0 12px rgba(76, 232, 206, 0.25))",
        }}
        draggable="false"
      />
      {showText && <span className="wordmark" style={{ fontSize: size * 0.42 }}>Y·E MUSIC</span>}
    </div>
  );
}
